import request from '@/utils/request'
const apiPath = '/course/courseTopicClassification'
const courseTopicClassificationApi = {
  /**
   * 新增【课程题目分类】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【课程题目分类】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 分页查询【课程题目分类】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query })
  },
  fetchOptions(query) {
    return request.get(apiPath + '/options', { params: query })
  },
  /**
   * 查看【课程题目分类】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【课程题目分类】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
}
export default courseTopicClassificationApi
